import { lazy } from "react";
import { ALLOWED_MODULES } from "../../constants/enums";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { MASTER_PARTNER_ROUTE } from "./partners.contant";

const PartnerList = Loadable(
	lazy(() =>
		import("./PartnerList").then(({ PartnerList }) => ({
			default: PartnerList,
		}))
	)
);


const ManagePartners = Loadable(
	lazy(() =>
		import("./ManagePartners").then(({ ManagePartners }) => ({
			default: ManagePartners,
		}))
	)
);

const BulkActivation = Loadable(
	lazy(() =>
		import("./BulkActivation/BulkActivation").then(({ BulkActivation }) => ({
			default: BulkActivation,
		}))
	)
);

const BulkUploadList = Loadable(
	lazy(() =>
		import("./BulkActivation/BulkUploadList").then(({ BulkUploadList }) => ({
			default: BulkUploadList,
		}))
	)
);

const PartnerMebershipList = Loadable(
	lazy(() =>
		import("./Membership/PartnerMebershipList").then(({ PartnerMebershipList }) => ({
			default: PartnerMebershipList,
		}))
	)
);

const PartnerMebershipList2 = Loadable(
	lazy(() =>
		import("./Membership/PartnerMebershipList2").then(({ PartnerMebershipList2 }) => ({
			default: PartnerMebershipList2,
		}))
	)
);

const PartnerMembershipConnections = Loadable(
	lazy(() =>
		import("./Membership/PartnerMembershipConnections").then(({ PartnerMembershipConnections }) => ({
			default: PartnerMembershipConnections,
		}))
	)
);

const ManagePartnerMembership = Loadable(
	lazy(() =>
		import("./Membership/ManagePartnerMembership").then(({ ManagePartnerMembership }) => ({
			default: ManagePartnerMembership,
		}))
	)
);
const PartnerComplaints = Loadable(
	lazy(() =>
		import("./Complaints/PartnerComplaints").then(({ PartnerComplaints }) => ({
			default: PartnerComplaints,
		}))
	)
);

// const ComplaintReportTab = Loadable(
// 	lazy(() =>
// 		import("../ComplaintReport/ComplaintReport-tab").then(({ ComplaintReportTab }) => ({
// 			default: ComplaintReportTab,
// 		}))
// 	)
// );

const PackageList = Loadable(
	lazy(() =>
		import("./Package/PackageList").then(({ PackageList }) => ({
			default: PackageList,
		}))
	)
);

const ManagePackage = Loadable(
	lazy(() =>
		import("./Package/ManagePackage").then(({ ManagePackage }) => ({
			default: ManagePackage,
		}))
	)
);


export const partnerRoutes = [
	{
		path: MASTER_PARTNER_ROUTE,
		exact: true,
		element: (
			<AuthorizedRoute
				allowFullAccess
				moduleIds={[ALLOWED_MODULES.PARTNERS]}
			>
				<PartnerList />
			</AuthorizedRoute>
		),
	},
	{
		path: `${MASTER_PARTNER_ROUTE}/manage`,
		exact: true,
		element: (
			<AuthorizedRoute
				moduleIds={[ALLOWED_MODULES.PARTNERS]}
			>
				<ManagePartners />
			</AuthorizedRoute>
		),
	},
	{
		path: `${MASTER_PARTNER_ROUTE}/manage/:uuid`,
		exact: true,
		element: (
			<AuthorizedRoute
				moduleIds={[ALLOWED_MODULES.PARTNERS]}
			>
				<ManagePartners />
			</AuthorizedRoute>
		),
	},
	{
		path: `${MASTER_PARTNER_ROUTE}/membership-list`,
		exact: true,
		element: (
			<AuthorizedRoute
				moduleIds={[ALLOWED_MODULES.PARTNERS_MEMBERSHIP]}
			>
				<PartnerMebershipList />
			</AuthorizedRoute>
		),
	},
	{
		path: `${MASTER_PARTNER_ROUTE}/latest-membership-list`,
		exact: true,
		element: (
			<AuthorizedRoute
				moduleIds={[ALLOWED_MODULES.PARTNERS_MEMBERSHIP]}
			>
				<PartnerMembershipConnections />
			</AuthorizedRoute>
		),
	},
	{
		path: `${MASTER_PARTNER_ROUTE}/membership-connections`,
		exact: true,
		element: (
			<AuthorizedRoute
				moduleIds={[ALLOWED_MODULES.PARTNERS_MEMBERSHIP]}
			>
				<PartnerMembershipConnections />
			</AuthorizedRoute>
		),
	},
	{
		path: `${MASTER_PARTNER_ROUTE}/partner-membership-list`,
		exact: true,
		element: (
			<AuthorizedRoute
				moduleIds={[ALLOWED_MODULES.PARTNERS_MEMBERSHIP]}
			>
				<PartnerMembershipConnections />
			</AuthorizedRoute>
		),
	},

	{
		path: `${MASTER_PARTNER_ROUTE}/membership/manage/:uuid`,
		exact: true,
		element: (
			<AuthorizedRoute
				moduleIds={[ALLOWED_MODULES.PARTNERS_MEMBERSHIP]}
			>
				<ManagePartnerMembership />
			</AuthorizedRoute>
		),
	},
	{
		path: `${MASTER_PARTNER_ROUTE}/bulk-activation`,
		exact: true,
		element: (
			<AuthorizedRoute
				moduleIds={[ALLOWED_MODULES.BULK_ACTIVATION]}
			>
				<BulkActivation />
			</AuthorizedRoute>
		),
	},
	{
		path: `${MASTER_PARTNER_ROUTE}/bulk-uploaded-list`,
		exact: true,
		element: (
			<AuthorizedRoute
				moduleIds={[ALLOWED_MODULES.BULK_ACTIVATION]}
			>
				<BulkUploadList />
			</AuthorizedRoute>
		),
	},
	{
		path: `${MASTER_PARTNER_ROUTE}/complaints`,
		exact: true,
		element: (
			<AuthorizedRoute
				moduleIds={[ALLOWED_MODULES.COMPLAINTS]}
			>
				<PartnerComplaints />
			</AuthorizedRoute>
		),
	},
	// {
	// 	path: `${MASTER_PARTNER_ROUTE}/complaint-report`,
	// 	exact: true,
	// 	element: (
	// 		<AuthorizedRoute
	// 			moduleIds={[ALLOWED_MODULES.COMPLAINTS]}
	// 		>
	// 			<ComplaintReportTab />
	// 		</AuthorizedRoute>
	// 	),
	// },
	{
		path: `${MASTER_PARTNER_ROUTE}/packages`,
		exact: true,
		element: (
			<AuthorizedRoute
				moduleIds={[ALLOWED_MODULES.PARTNER_PACKAGE_MASTER]}
			>
				<PackageList />
			</AuthorizedRoute>
		),
	},
	{
		path: `${MASTER_PARTNER_ROUTE}/packages/manage/:uuid`,
		exact: true,
		element: (
			<AuthorizedRoute
				moduleIds={[ALLOWED_MODULES.PARTNER_PACKAGE_MASTER]}
			>
				<ManagePackage />
			</AuthorizedRoute>
		),
	},
	{
		path: `${MASTER_PARTNER_ROUTE}/packages/manage`,
		exact: true,
		element: (
			<AuthorizedRoute
				moduleIds={[ALLOWED_MODULES.PARTNER_PACKAGE_MASTER]}
			>
				<ManagePackage />
			</AuthorizedRoute>
		),
	},
];
